<template>
  <v-container fluid style="max-width: 1400px; margin-left: 0;"
		class="report-full-container"
		:class="isScrolled ? 'pt-0' : ''"
		:style="'height:'+$store.getters['general/availableHeight']+'px;overflow:scroll;'"
		@scroll="onScroll">
		<div v-if="loadingReportInfo">
			<p class="text-center caption">Cargando Presupuesto Desarchivo</p>
			<v-skeleton-loader
				type="heading"
				class="my-2 mx-6"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="paragraph"
				class="my-2 mx-6"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="text"
				class="my-2 mx-6"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="paragraph"
				class="my-2 mx-6"
			></v-skeleton-loader>
		</div>
		<div v-else>
			<v-card class="budget-modal-card mb-2"
				ref="reportHeaderInfo"
				:style="isScrolled ? {
					position: 'sticky',
					top: '0px',
					left: '0',
					right: '0',
					zIndex: 99
				} : {}">
				<v-card-text class="py-4">
					<div class="d-flex align-center justify-space-between"
						:class="showReportDetail ? 'mb-2' : ''">
						<p class="mb-0 font-weight-bold">Detalle Informe / Proyecto</p>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									text
									color="#524D4D"
									x-small
									v-bind="attrs"
									v-on="on"
									@click="toggleReportDetail()"
								>
									<v-icon dark small>{{showReportDetail ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
									<p class="mb-0 ml-2 caption">{{showReportDetail ? 'Ocultar' : 'Ver'}} Detalles Informe / Proyecto</p>
								</v-btn>
							</template>
							<span>Ver Detalle</span>
						</v-tooltip>
					</div>
					<div class="d-flex align-start flex-grow-1 caption" v-if="report && showReportDetail">
						<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
								<div style="width: 120px; min-width: 120px;">Informe</div><span>:</span> <b class="text-end" style="flex: 1;">{{ report.serial?.serial }} - LP{{ report.morphable?.project_line_info?.project_line?.number }} - {{ report.prefix?.prefix }} {{ report.report_index }}</b>
								<div class="action-container">
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
								<div style="width: 120px; min-width: 120px;">Detalle</div><span>:</span>
								<div class="d-flex flex-column flex-grow-1 justify-end">
									<div class="d-flex flex-grow-1 justify-end caption">
										<v-icon x-small class="mr-2">{{getTypeIcon(report.morphable_type)}}</v-icon> <p class="mb-0 font-weight-bold" style="font-size: 10px;">{{ getTypeName(report.morphable_type)}}</p>
									</div>
									<div class="d-flex flex-grow-1 justify-end caption">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<p
													class="mb-0 text-truncate"
													style="max-width: 180px;"
													v-bind="attrs"
													v-on="on"
												>
													{{ report.morphable?.name || report.morphable?.info?.project_detail }}
												</p>
											</template>
											<span>{{ report.morphable?.name || report.morphable?.info?.project_detail }}</span>
										</v-tooltip>
									</div>
								</div>
								<div class="action-container align-start">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												color="warning"
												x-small
												v-bind="attrs"
												v-on="on"
												@click="gotToAssociation(report)"
											>
												<v-icon dark small>mdi-eye-outline</v-icon>
											</v-btn>
										</template>
										<span>Ir al detalle</span>
									</v-tooltip>
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Dirección</div><span>:</span>
								<div class="d-flex flex-grow-1 justify-end align-center ml-2">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<p
												class="mb-0 text-truncate caption"
												style="max-width: 200px;"
												v-bind="attrs"
												v-on="on"
											>
												{{ report.morphable?.info?.address?.address }}
											</p>
										</template>
										<span>{{ report.morphable?.info?.address?.address }}</span>
									</v-tooltip>
								</div>
								<div class="action-container"></div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Estado</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<div>
										<v-chip
											:color="report.last_status?.status | budgetStatusColor"
											label
											outlined
											x-small
										>
											<b>{{ report.last_status?.status | budgetStatus }}</b>
										</v-chip>
									</div>
									<!-- <div>
										<v-chip
											:color="report.last_status?.status | budgetStatusColor"
											label
											outlined
											x-small
										>
											<b>{{ report.last_status?.status | budgetStatus }}</b>
										</v-chip>
									</div> -->
								</div>
								<div class="action-container"></div>
							</div>
						</div>
						<v-divider class="mx-2" vertical></v-divider>
						<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
								<div style="width: 120px; min-width: 120px;">Responsable</div><span>:</span> <b class="text-end" style="flex: 1;">{{ userResponsible ? userResponsible:'Sin Responsable' }}</b>
								<div class="action-container">
									<v-menu v-model="responsibleMenu" offset-y z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
										<template v-slot:activator="{ on, attrs }">
											<div class="action-container">
												<v-tooltip bottom>
													<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
														<v-btn
															icon
															color="warning"
															x-small
															:disabled="!$checkPermissions(['assign_responsible_user'])"
															v-bind="{ ...attrs, ...tooltipAttrs }"
															v-on="{ ...on, ...tooltipOn }"
														>
															<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
														</v-btn>
													</template>
													<span>Cambiar Responsable</span>
												</v-tooltip>
											</div>
										</template>
										<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
											<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
												<p class="caption mb-0 font-weight-bold white--text">Cambiar Responsable</p>
											</v-list-item>
											<v-list-item-group color="#524D4D">
												<v-list-item
													v-for="(responsible, index) in $store.state.users.usersList"
													:key="index"
													dense
													@click="changeResponsible(responsible.id)"
												>
													<v-list-item-title dense>
														<div class="d-flex align-center">
															<img :src="responsible.profile.avatar" class="user-avatar mr-2" v-if="responsible?.profile?.avatar"/>
															<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
															<div>
																<p class="mb-0">{{ responsible.profile?.name }} {{ responsible.profile?.lastname }} {{ responsible.profile?.second_lastname }}</p>
																<p class="mb-0 caption">{{ responsible.email }}</p>
															</div>
														</div>
													</v-list-item-title>
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</v-menu>
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Cliente</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{clientName}}</p>
								</div>
								<div class="action-container">
									<v-menu v-model="userCompanyMenu" offset-y nudge-left="350px" z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;"
										v-if="report.morphable?.client?.company_profile && report.morphable?.client?.accreditation?.status">
										<template v-slot:activator="{ on, attrs }">
											<v-tooltip bottom>
												<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
													<v-btn
														icon
														color="#FF1209"
														x-small
														v-bind="{ ...attrs, ...tooltipAttrs }"
														v-on="{ ...on, ...tooltipOn }"
													>
														<v-icon dark small>mdi-domain</v-icon>
													</v-btn>
												</template>
												<span>Cliente Empresa</span>
											</v-tooltip>
										</template>
										<v-card min-width="400px">
											<v-card-text>
												<div class="caption" v-if="report.morphable?.client?.company_profile">
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre Empresa</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.name}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.rut | formatRut}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.email}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Teléfono</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.phone}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.address}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.rep_name}} {{report.morphable?.client?.company_profile.rep_first_lname}} {{report.morphable?.client?.company_profile.rep_second_lastname}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.email}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.rep_rut | formatRut}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.rep_address}}</b></div>
												</div>
											</v-card-text>
										</v-card>
									</v-menu>
									<v-tooltip bottom v-else>
										<template v-slot:activator="{ on, attrs }">
											<v-icon small color="#959595"
												v-bind="attrs"
												v-on="on">mdi-account</v-icon>
										</template>
										<span>Cliente Persona Natural</span>
									</v-tooltip>
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Rut</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{report.morphable?.client?.profile?.rut | formatRut}}</p>
								</div>
								<div class="action-container"></div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Teléfono</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{report.morphable?.client?.profile?.phone}}</p>
								</div>
								<div class="action-container"></div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Email</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{report.morphable?.client?.email}}</p>
								</div>
								<div class="action-container"></div>
							</div>
						</div>
						<v-divider class="mx-2" vertical></v-divider>
						<div class="d-flex flex-column justify-end align-end" style="width: 270px;min-width: 270px;">
							<div class="d-flex flex-column align-start justify-end" style="width: 100%;">
								<div class="d-flex justify-end align-center mb-1 flex-1" style="width: 100%;">
									<div style="width: 100%;" class="mr-2">
										<v-btn
											depressed
											color="#FF120B"
											class="mb-1 flex-grow-1"
											x-small
											:dark="!blockedReport"
											:disabled="blockedReport"
											block
										>
											<v-icon small>mdi-check</v-icon>
											<p class="mb-0 ml-1 caption">Guardar</p>
										</v-btn>
										<!-- <v-btn
											depressed
											color="#FF120B"
											class="flex-grow-1"
											x-small
											dark
											block
											@click="newWindowOnlyOffice"
										>
											<v-icon small>mdi-open-in-new</v-icon>
											<p class="mb-0 ml-1 caption">Abrir en nueva ventana</p>
										</v-btn> -->
									</div>
									<ReportPdfHistory :report="report" />
								</div>
								<div class="d-flex align-start justify-end" style="width: 100%;">
									<div class="d-flex flex-column align-end justify-end" style="width: 100%;" v-if="userResponsible">
										<div style="width: 100%;">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														depressed
														color="#959595"
														dark
														class="mb-1"
														small
														outlined
														block
														@click="openNewProjectModal(report.morphable, 2)"
														v-bind="attrs"
														v-on="on"
													>
														<v-icon small>mdi-book-outline</v-icon>
														<p class="mb-0 ml-2 caption">Pasar a Presupuesto</p>
													</v-btn>
												</template>
												<span>Pasar el informe a presupuesto</span>
											</v-tooltip>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														depressed
														color="#959595"
														dark
														class="mb-1"
														small
														outlined
														block
														@click="createContract"
														v-bind="attrs"
														v-on="on"
													>
														<v-icon small>mdi-briefcase-outline</v-icon>
														<p class="mb-0 ml-2 caption">Pasar a Contrato</p>
													</v-btn>
												</template>
												<span>Pasar el informe a contrato</span>
											</v-tooltip>
											<div class="mt-3 mb-1" style="width: 100%;">
												<v-select
													:value="report.budget.tax_id"
													:items="taxOptions"
													:loading="$store.state.general.loadingTaxesOptions"
													:menu-props="{ top: true, offsetY: true }"
													item-text="name"
													item-value="id"
													label="Tipo Impuesto"
													class="custom-height-search custom-height-calendar flex-grow-0"
													outlined
													dense
													required
													return-object
													:disabled="blockedReport"
													@change="changeTaxSelection"
												>
													<template v-slot:item="data">
														<v-list-item-content>
															<v-list-item-title>
																<div class="d-flex align-center justify-space-between">
																	<div class="d-flex align-center justify-space-between flex-1">
																		<p class="mb-0 flex-1">{{data.item.tax.name}}</p>
																		<p class="mb-0 font-weight-bold">{{data.item.tax.value}}%</p>
																	</div>
																</div>
															</v-list-item-title>
														</v-list-item-content>
													</template>
													<template v-slot:selection="data">
														<div class="d-flex align-center justify-space-between flex-1" style="min-width: 100%;">
															<p class="mb-0 caption flex-1">{{data.item.tax.name}}</p>
															<p class="mb-0 font-weight-bold caption">{{data.item.tax.value}}%</p>
														</div>
													</template>
												</v-select>
											</div>
											<v-tooltip bottom v-if="!blockedReport">
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														depressed
														color="#959595"
														:dark="!loadingEditorReport"
														small
														outlined
														block
														@click="reportToPdf"
														:loading="loadingEditorReport"
														:disabled="loadingEditorReport"
														v-bind="attrs"
														v-on="on"
													>
														<v-icon small>mdi-file-pdf-box</v-icon>
														<p class="mb-0 ml-2 caption">Generar PDF y Enviar Informe</p>
													</v-btn>
												</template>
												<span>Con esto podrás regenerar el PDF del informe con nueva información</span>
											</v-tooltip>
										</div>
										<ProjectLineDocumentsMenu :project_line_id="project?.project_line_info?.project_line_id" :size="'large'"/>
									</div>
									<div v-else>
										<v-chip
											class="wrap-chip text-center"
											color="#FF120B"
											label
											outlined
											x-small
										>
											<b>Para continuar por favor asigna un responsable</b>
										</v-chip>
									</div>
								</div>
							</div>
						</div>
					</div>
				</v-card-text>
			</v-card>
			<v-card :loading="loadingReportInfo" :disabled="loadingReportInfo" class="budget-modal-card mb-2" v-if="report.last_status?.status == budgetStatuses.OBSERVADO_CONTRAPARTE"
				ref="budgetSecondHeaderInfo"
				:style="isScrolled ? {
					position: 'sticky',
					top: reportHeaderHeight+'px',
					left: '0',
					right: '0',
					zIndex: 8
				} : {}">
				<v-card-text class="py-4">
					<div class="d-flex align-start caption" v-if="report">
						<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
							<div class="custom-warning-observation px-2 py-1">
								<p class="mb-0 caption font-weight-bold warning--text">Observaciones Cliente</p>
								<p class="mb-0 caption warning--text">Revisa la siguiente observación y envía un nuevo informe para revisión</p>
							</div>
						</div>
						<v-divider class="mx-2" vertical></v-divider>
						<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
							<p class="mb-0 caption font-weight-bold">Última Observación</p>
							<p class="mb-0">{{ report.last_observation?.observation }}</p>
						</div>
						<v-divider class="mx-2" vertical></v-divider>
						<div class="d-flex flex-column justify-end align-end" style="width: 270px;min-width: 270px;">
							<v-menu offset-y>
								<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
											<v-btn
												depressed
												color="#959595"
												dark
												small
												outlined
												v-bind="{ ...tooltipAttrs, ...menuAttrs }"
												v-on="{ ...tooltipOn, ...menuOn }"
											>
												<v-icon class="mr-2" small>mdi-briefcase-clock-outline</v-icon>
												<p class="caption mb-0">Historial de Observaciones</p>
											</v-btn>
										</template>
										<span>Historial de observaciones</span>
									</v-tooltip>
								</template>
								<v-list dense class="py-0 white">
									<v-list-item dense class="mb-0" style="min-height: 25px; background: #959595;">
										<div>
											<p class="caption mb-0 font-weight-bold white--text">Historial de Observaciones</p>
										</div>
									</v-list-item>
									<v-list-item dense class="my-0 py-0" style="min-height: 25px;">
										<div class="d-flex justify-space-between align-center flex-grow-1">
											<p class="caption mb-0 text--disabled">Observación</p>
											<p class="caption mb-0 text--disabled" style="width: 90px;">Fecha</p>
										</div>
									</v-list-item>
									<v-divider></v-divider>
									<v-list-item-group color="#524D4D" style="max-height: 350px;overflow-y:scroll;">
										<v-list-item
											v-for="(observation, index) in report.observations"
											:key="'reportstatus-'+index"
											dense
											style="min-width: 350px;max-width: 450px;"
											class="white"
										>
											<v-list-item-title dense>
												<div class="d-flex justify-space-between align-center item-background-hover">
													<div class="d-flex flex-1 align-center justify-space-between caption mr-6" style="flex-wrap: wrap; min-width: 0;">
														<p class="mb-0 text-wrap">{{ observation.observation }}</p>
													</div>
													<div class="d-flex justify-end caption" style="width: 90px;">
														<p class="mb-0 caption text-end">{{ observation.created_at | toDateTime }}</p>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>
					</div>
				</v-card-text>
			</v-card>
			<div
				class="d-flex flex-1 mt-2"
				:style="{ height: availableHeight + 'px' }"
			>
				<div v-if="report && report.pdf && report.pdf.file && blockedReport" class="d-flex flex-grow-1" style="min-height: 900px">
					<iframe :src="report.pdf.file.file_link" width="100%" class="fill-height d-flex flex-grow-1"></iframe>
				</div>
				<ReportBudgetTextEditor ref="reportTextEditorRef" v-else-if="report && selectedCompany && showEditor" :report="report"/>
			</div>
		</div>
	</v-container>
</template>

<script>
import budgetStatuses from '@/components/Helpers/Constants/budget.js'
import {getReportById, createReportPdfFromPreviewLegacy, sendReportPdfEmail, updateReport, deleteReportTitle} from '@/helpers/api/reports'
import {deleteVTReportTemplate} from '@/helpers/api/general'
import { createContract } from '@/helpers/api/contracts'

import {setResponsible as setResponsiblePreProject} from '@/helpers/api/preprojects'
import {setResponsible as setResponsibleProject} from '@/helpers/api/projects'
import {editCrmResponsible} from '@/helpers/api/crm'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'

import ReportBudgetTextEditor from '@/components/Helpers/Editor/ReportBudgetTextEditor.vue'
import ReportPdfHistory from '@/components/Helpers/Components/ReportPdfHistory'
import ProjectLineDocumentsMenu from '@/components/Views/Projects/Parts/ProjectLineDocumentsMenu'

export default {
	name: 'ReportBudgetDetail',
	components: {ReportBudgetTextEditor, ReportPdfHistory, ProjectLineDocumentsMenu},
	computed: {
		availableHeight(){
			const availableHeight = this.$store.getters['general/availableHeight'] - this.reportHeaderHeight - this.reportSecondHeaderHeight - 48
			return availableHeight
		},
		project(){
			return this.report?.morphable
		},
		taxOptions(){
			return this.$store.state.general.taxesOptions
		},
		blockedReport(){
			return this.report?.last_status?.status == budgetStatuses.ACEPTADO || this.report?.last_status?.status == budgetStatuses.PAGADO
		},
		userInfo(){
			if(this.report.morphable?.user){
				const user = this.report.morphable?.user
				if(user && user.user && user.user.profile){
					return {
						name: user.user.profile.name,
						lastname: user.user.profile.lastname,
						second_lastname: user.user.profile.second_lastname,
						email: user.user.email || '--',
						rut: user.user.profile.rut || '--',
						phone: user.user.profile.phone || '--',
						account: true
					}
				}
				return {
					name: user.name,
					lastname: user.lastname,
					second_lastname: user.second_lastname,
					rut: user.rut || '--',
					email: user.email || '--',
					phone: user.phone || '--',
				}
			}
			return null
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		openReportModal(){
			return this.$store.state.general.newReportModal
		},
		userResponsible(){
			if(this.report.morphable?.responsible?.profile){
				let fullName = this.report.morphable?.responsible?.profile?.name
				if(this.report.morphable?.responsible?.profile?.lastname){
					fullName = fullName + ' ' + this.report.morphable?.responsible?.profile?.lastname + ' ' + this.report.morphable?.responsible?.profile?.second_lastname
				}
				return fullName
			}
			return null
		},
		clientName(){
			let client_name = 'No Disponible'
			if(this.report.morphable?.client?.profile){
				client_name = this.report.morphable.client.profile.name + ' ' + this.report.morphable.client.profile.lastname + ' ' + this.report.morphable.client.profile.second_lastname
			}
			else if(this.getType(this.report.morphable_type) == 'crm' && this.report.morphable?.user){
				if(this.report.morphable.user?.user?.profile){
					client_name = (this.report.morphable.user?.user?.profile?.name ?? '') + ' ' + 
									(this.report.morphable.user?.user?.profile?.lastname ?? '') + ' ' + 
									(this.report.morphable.user?.user?.profile?.second_lastname ?? '')
				}
				else{
					client_name = (this.report.morphable.user.name ?? '') + ' ' +
												(this.report.morphable.user.lastname ?? '') + ' ' +
												(this.report.morphable.user.second_lastname ?? '')
				}
			}
			return client_name
		},
		item(){
			return this.$store.state.general.newReportModal.item
		},
		queryRoute(){
			return this.$route.query
		},
		reportHeaderHeight(){
			return this.$store.state.reports.reportHeaderHeight
		},
		reportSecondHeaderHeight(){
			return this.$store.state.reports.reportSecondHeaderHeight
		},
		isScrolled(){
			return this.$store.state.reports.scrolledReport > 0
		},
		paymentStatus(){
			const payed = this.report.budget?.payment_order
			if(payed){
				return {
					text: 'Pagado',
					date: this.report.budget?.payment_order?.payment_info?.payment_date,
					color: 'success'
				}
			}
			return {
				text: 'Esperando Pago',
				color: 'warning'
			}
		}
	},
	watch: {
		selectedCompany(newValue){
			if(newValue){
				this.$store.dispatch('users/getUserFromCompany')
				this.$store.dispatch('reports/getReportTitles')
				this.$store.dispatch('vt/getVtReportTemplates')
			}
		},
		queryRoute(){
			const report_id = this.$route.query.id
			if(this.report && this.report.id != report_id){
				this.report = null
				this.getReportInfo()
			}
		},
		report(){
			if(this.report){
				this.showEditor = false
				this.$nextTick(() => {
					this.showEditor = true
				})
			}
		},
		loadingReportInfo(val){
      if (!val) {
        this.$nextTick(() => {
          this.initResizeObserver();
        });
      }
		}
	},
  data() {
    return {
			budgetStatuses,
			menuOpen: false,
			userCompanyMenu: false,
			showEditor: false,
			menuTitle: false,
			menuTemplates: false,
			prefixMenu: false,
			loadingReportInfo: true,
			responsibleMenu: false,
			loadingReport: false,
			report_id: null,
			report: null,
			showReportDetail: true,
      resizeObserver: null,
			loadingEditorReport: false
		}
	},
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
	mounted(){
		if(this.selectedCompany){
			this.$store.dispatch('users/getUserFromCompany')
			this.$store.dispatch('reports/getReportTitles')
			this.$store.dispatch('vt/getVtReportTemplates')
		}
		this.getReportInfo()
		this.initResizeObserver()
		eventBus.$on('reloadInformation', this.getReportInfo)
	},
	beforeDestroy() {
		eventBus.$off('reloadInformation', this.getReportInfo)
	},
	methods: {
		async changeTaxSelection(tax){
			if (!this.report.budget) return

			this.report.budget = {
				...this.report.budget,
				tax_id: tax.tax.id,
				tax_value: tax.tax
			}
			await updateReport({
				report_id: this.report.id,
				tax_id: tax.tax.id
			})
			this.getReportInfo()
		},
		toggleReportDetail(){
			this.showReportDetail = !this.showReportDetail
		},
		onScroll(event){
			this.$store.commit('reports/setScrolledReport', event.target.scrollTop)
		},
    initResizeObserver() {
      const el = this.$refs.reportHeaderInfo?.$el || this.$refs.reportHeaderInfo;
			const el2 = this.$refs.reportSecondHeaderInfo?.$el || this.$refs.reportSecondHeaderInfo;
      if (!el || !el2) return;

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      this.resizeObserver = new ResizeObserver(() => {
				this.$store.commit('reports/setReportHeaderHeight', el.offsetHeight)
				this.$store.commit('reports/setReportSecondHeaderHeight', el2.offsetHeight)
      });

      this.resizeObserver.observe(el);
      this.resizeObserver.observe(el2);
    },
		async getReportInfo(){
			const report = await getReportById({report_id: this.$route.query.id})
			if(report.code == 200){
				this.report = report.report
			}
			this.loadingReportInfo = false
		},
		reverseContentViewToPlaceholders(content) {
			let result = content;
			result = result.replace(/<span id="(.*?)"[^>]*>(.*?)<\/span>/g, (match, placeholder) => {
					return `${placeholder}`;
			})
			return result;
		},
		async reportToPdf(){
			this.loadingEditorReport = true
			const contentEditorRef = this.$store.state.reports.reportEditorRef
			// const data = {
			// 	report_id: this.report.id,
			// 	contents: JSON.stringify( contentEditorRef.pages.map(page => page.prev_innerHTML) )
			// }
			const data = {
				report_id: this.report.id,
				contents: JSON.stringify( contentEditorRef.pages.map(page => this.reverseContentViewToPlaceholders(page.prev_innerHTML) ) )
			}
			const pdf = await createReportPdfFromPreviewLegacy(data)
			if(pdf.code == 200){
				const report = {...this.report, ...{pdf: pdf.report_pdf}}
				this.$store.commit('reports/setReportPdfModal', report)
				this.getReportInfo()
			}
			this.loadingEditorReport = false
		},
		getType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'crm'
				case "App\\Models\\PreProject":
					return 'preproject'
				case "App\\Models\\Project":
					return 'project'
				default:
					break;
			}
			return 'Otro'
		},
		getTypeIcon(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'mdi-contacts-outline'
				case "App\\Models\\PreProject":
					return 'mdi-information-variant-circle-outline'
				case "App\\Models\\Project":
					return 'mdi-ruler-square'
				default:
					break;
			}
			return 'Otro'
		},
		getTypeName(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					break;
			}
			return 'Otro'
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
		gotToAssociation(item){
			const item_type = this.getType(item.morphable_type)
			if(item_type == 'crm'){
				// this.$router.push({ name: 'Conversation', params: { id: item.morphable_id } })
				this.$store.commit('crm/setCrmModalId', item.morphable_id )
			}
			else if(item_type == 'preproject'){
				// this.$router.push({ name: 'PreProject', params: { id: item.morphable_id } })
				this.$store.commit('preprojects/setPreProjectModalId', item.morphable_id)
			}
			else if(item_type == 'project'){
				const messageData = {
					message: 'Detalle de proyectos en futuro módulo Proyectos',
					title: 'Sección en construcción',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async changeResponsible(responsible_id){
			const item_type = this.getType(this.report.morphable_type)
			if(item_type == 'crm'){
				// await assignScheduleToUser({schedule_id: this.report.morphable.schedule.user_schedule.id, new_user_id: responsible_id})
				await editCrmResponsible({conversation_id: this.report.morphable_id, responsible_id})
			}
			else if(item_type == 'preproject'){
				await setResponsiblePreProject({preproject_id: this.report.morphable_id, responsible_id})
			}
			else if(item_type == 'project'){
				await setResponsibleProject({project_id: this.report.morphable_id, responsible_id})
			}
			this.getReportInfo()
			this.responsibleMenu = false
		},
		async sendEmailReport(){
			const report_r = await sendReportPdfEmail({report_id: this.report.id})
			if(report_r.code === 200){
				const messageData = {
					message: 'Se ha enviado correctamente el presupuesto por correo',
					title: 'Presupuesto enviado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
    async createContract(){
      if(this.report.morphable_id){
				if(this.getType(this.report.morphable_type) != 'project'){
					this.openNewProjectModal({
						...this.report.morphable,
						morphable_type: this.getType(this.report.morphable_type),
					})
					return null
				}
				const data = {
					item_type: this.getType(this.report.morphable_type),
					item_id: this.report.morphable_id
				}
        const contract = await createContract(data)
        if(contract.code === 200){
					if(contract.existent){
						const source = contract.contract || contract.budget;
						if (source) {
							const dataInfo = {
								...source,
								doc_type: 1,
							};
							this.$store.commit('general/setExistentDocumentNotificationModalData', dataInfo);
							this.$store.commit('general/setExistentDocumentNotificationModal', true);
						}
						return
					}
          const messageData = {
            message: 'Se ha creado correctamente el contrato',
            title: 'Contrato creado',
            type: 'success',
            icon: 'mdi-check-circle',
            color: '#3EBFA3',
          }
					this.$store.commit('contracts/setContractComponentModalId', contract.contract.id)
					// this.$router.push({ name: 'ContractDetail', query: { id: contract.contract.id } })
          this.setMessage(messageData)
        }
        else{
          const messageData = {
            message: 'Hubo un error en la operación, por favor intenta nuevamente',
            title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
          }
          this.setMessage(messageData)
        }
      }
    },
		openNewProjectModal(preproject, doc_type){
			const pre_project = {
				...this.report.morphable,
				...{doc_type},
				morphable_type: this.getType(this.report.morphable_type),
			}
			this.$store.commit('projects/setProjectModalInfo', pre_project)
			this.$store.commit('projects/setProjectModal', true)
		},
		async editReportTemplate(reportTemplate, duplicating = false){
			const rt = {...reportTemplate}
			if(duplicating){
				rt.name = rt.name + ' (Copia)'
				delete rt.id
			}
			this.$store.commit('vt/setNewReportTemplateEditing', rt)
      this.$store.commit('vt/setNewReportTemplateModal', true)
		},
		async deleteVTReportTemplates(template_id){
			await deleteVTReportTemplate({template_id})
			this.$store.dispatch('vt/getVtReportTemplates')
		},
		onChangeReportTemplate(template){
			this.menuTemplates = false
			setTimeout(() => {
				this.$refs.reportTextEditorRef.setTemplate(template)
				this.$nextTick(() => {
					setTimeout(() => {
						this.updateReportContent()
				}, 200)
				})
			}, 200)
		},
		async updateReportContent(){
			const contentEditorRef = this.$store.state.reports.reportEditorRef
			const response = await updateReport({
				report_id: this.report.id,
				report_html: contentEditorRef.pages.map(page => this.reverseContentViewToPlaceholders(page.prev_innerHTML))
			})
			if(response.code == 200){
				const messageData = {
					message: 'Contenido del informe guardado',
					title: 'Informe guardado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
		},
		async onChangeTitle(title){
			this.budget = {...this.budget, ...{title}}
			await updateReport({
				report_id: this.report.id,
				title
			})
			this.getReportInfo()
		},
		setReportTitle(title = null){
			this.$store.commit('reports/setNewReportTitleModalEditing', title ? {...title, ...{report_title_id: title.id}}:null)
      this.$store.commit('reports/setNewReportTitleModal', true)
		},
		async deleteBugdetTitle(title){
			await deleteReportTitle({report_title_id: title.id})
			this.$store.dispatch('reports/getReportTitles')
		},
	}
}
</script>

<style>
	.report-full-container{
		position: relative;
	}
	.v-dialog.budget-modal-custom{
		max-width: 1200px;
		width: 90vw;
		height: 95vh;
		max-height: 95vh;
	}
	.budget-note-tiny-editor {
		max-height: 140px !important;
		overflow: auto !important;
	}
</style>

<style scoped>
	.action-container{
		width: 30px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.custom-warning-observation{
		border: 1px solid #fb8c00;
		border-radius: 6px;
	}
	/deep/ .budget-note-container p{margin-bottom: 0;}
</style>